import { Card, Checkbox, Form, Input, Typography } from "antd";
import Inputmask from "inputmask";
import { observer } from "mobx-react";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import ChildCheked from "../../assets/Calculator/Child_Checked.svg";
import ChildBG from "../../assets/Calculator/Child_Check_BG.svg";
import ChildDrop from "../../assets/Calculator/Child_Check_Drop.svg";
import RetireCheked from "../../assets/Calculator/Retire_Checked.svg";
import RetireBG from "../../assets/Calculator/Retire_Check_BG.svg";
import RetireDrop from "../../assets/Calculator/Retire_Check_Drop.svg";
import WealthCheked from "../../assets/Calculator/Wealth_Checked.svg";
import WealthBG from "../../assets/Calculator/Wealth_Check_BG.svg";
import WealthDrop from "../../assets/Calculator/Wealth_Check_Drop.svg";
import { DataLayerFn, leadWSAPI, tracerAPI } from "../../Configs/API";
import calculatorForm from "../../Configs/JSON/calculatorForm.json";
import FormStore from "../../Configs/Store/forms";
import CommonStore from "../../Configs/Store/common";
import AppStore from "../../Configs/Store/index";
import ModalStore from "../../Configs/Store/modals";
import {
  ageValidation,
  emailValidation,
  phoneValidation,
} from "../../Configs/Validator/FormValidations";
import {
  getCookieBoi,
  getStorageBoi,
  getReactStorageBoi,
  isJson,
  capitalize,
  BlowFishReact,
  maskData,
  maskMobile,
  maskEmail,
  HideLandingLoader,
  InjectCustomAppForm,
  addCommas,
  NDNC_DISCLAIMER_TRUNCATED,
  NDNC_DISCLAIMER_FULL,
  maskDetail,
  CreateReactCookie,
} from "../Common/CommonFunctions";
import GenericButton from "../Common/GenericButton";
import IconTooltip from "../Common/IconTooltip";
import RadioCheck from "../Common/RadioCheck";
import RadioGroup from "../Common/RadioGroup";
import { UserInput } from "../QuoteScreen/QuoteAPI";
import "./Calculator.less";
import AI_Modal from "./AI_Modal";
import MobileModal from "./MobileModal";
import DependentModal from "./DependentModal.js";
import getUserDataJSON from "../../Configs/JSON/UserData";

const ConfigObj = [
  {
    key: "Wealth",
    bgImg: WealthBG,
    bgChecked: WealthBG,
    dropSvg: WealthDrop,
    itemChecked: WealthCheked,
  },
  {
    key: "Retirement",
    bgImg: RetireBG,
    bgChecked: WealthBG,
    dropSvg: RetireDrop,
    itemChecked: RetireCheked,
  },
  {
    key: "Child",
    bgImg: ChildBG,
    bgChecked: WealthBG,
    dropSvg: ChildDrop,
    itemChecked: ChildCheked,
  },
];

const Calculator = observer(({ calcFormRef, quoteFormRef, QuoteAPI }) => {
  const [disableQData, setDisableQData] = useState(false);
  const dobInput = useRef({});
  const mobInput = useRef(null);
  const emailInput = useRef(null);
  const suitInput = useRef(null);
  const SaveNGrowForm = useRef(null);
  const [CalculatorCTADisabled, setCalculatorCTADisabled] = useState(false);
  const [viewMore, setViewMore] = useState(true);

  useEffect(() => {
    setTimeout(async () => {
      const isAppResume = AppStore.isResumeJourney; // Priority High
      if (isAppResume) {
        FormStore.setQuoteModal(true);
      } else {
        const isQDataAvail = await checkQDATA(); // Priority Medium
        if (!isQDataAvail) {
          const isLocalAvail = await preFillByLocalStorage(); // Priority Low
        }
      }
    }, 100);
  }, []);

  //Applying masking
  useEffect(() => {
    if (!FormStore.PiiMaskFlag) return;

    applyMask("mobileItem");
    applyMask("emailItem");
  }, [FormStore.PiiMaskFlag]);

  const applyMask = async (fieldName) => {
    const val = calcFormRef.getFieldValue(fieldName);
    if (!val || val.includes("X")) return;
    await calcFormRef.setFieldsValue({
      [fieldName]: maskDetail(val),
    });
  };

  const sharpQData = (name, query) => {
    if (!query) query = window.location.search;
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(query);

    if (results === null) return "";
    else return decodeURIComponent(results[1]);
  };

  const checkQDATA = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    var qDataTest = params["qdata"];
    if (qDataTest !== "" && qDataTest !== undefined && qDataTest !== null) {
      var decryptQdata = await sharpQData("qdata");
      var qdata = await BlowFishReact(false, "", decryptQdata);

      if (qdata !== undefined) {
        if (isJson(qdata)) {
          var tempObj_1 = JSON.parse(qdata);
          preFillData(tempObj_1, true, false);
        } else {
          qdata = await BlowFishReact(false, "DIGI", decryptQdata);
          var tempObj_2 = JSON.parse(qdata);
          preFillData(tempObj_2, true, true);
          if (params["Step"] !== "true") {
            setDisableQData(true);
          }
        }
      }
      return true;
    } else {
      return false;
    }
  };

  const preFillByLocalStorage = async () => {
    var cookieDob = await getCookieBoi("dob");

    if (typeof cookieDob === "string") {
      window.UserInput["dob"] = cookieDob;

      setTimeout(async () => {
        var cookieProdId = await getCookieBoi("SigproductId");
        var localData = await getReactStorageBoi("productInfoSIGNATURE");

        console.log(
          "preFillByLocalStorage",
          localData,
          cookieProdId,
          cookieDob,
        );
        var prodId_1 = "UW3";

        if (cookieProdId && localData) {
          if (cookieProdId === prodId_1) {
            if (cookieDob === localData["dob"]) {
              var UW3Storage = localData;
              setTimeout(preFillData, 100, UW3Storage);
            }
          }
          return true;
        }
      }, 1500);
    }
    return false;
  };

  const preFillData = async (tempObj, QDataFlag, maskFlag = false) => {
    FormStore.setPiiMaskFlag(true);
    if (QDataFlag) {
      //if coming from Suitability, then hide Suitability Checkbox.
      FormStore.setQuoteCheckTwo(true);
      FormStore.setCalcCheckTwo(true);
      // FormStore.setSuitabilityFlag(true)
    }
    console.info("preFillData :", tempObj);
    // Lead Page // Level 1

    var value;
    if (!FormStore.persona_Validity) {
      // If Persona Exists, Use URL
      if (tempObj["FFGoal"] !== undefined) {
        var goalArray = ["Wealth", "Retirement", "Child"];
        value = tempObj["FFGoal"];
        if (goalArray.includes(value)) {
          FormStore.setCalcType(value);
          UserInput("calcType", value, "key", "");
        }
      }
      if (tempObj["calcType"] !== undefined) {
        value = tempObj["calcType"]["key"];
        FormStore.setCalcType(value);
        UserInput("calcType", value, "key", "");
      }
    }

    if (tempObj["EmailId"] !== undefined) {
      value = tempObj["EmailId"];
      FormStore.setCalcEmail(value);
      calcFormRef.setFieldsValue({
        emailItem: FormStore.PiiMaskFlag ? maskDetail(value) : value,
      });
      emailInput.current.value = value;
      UserInput("EmailId", value, "", "");
    }
    if (tempObj["Email"] !== undefined) {
      value = tempObj["Email"];
      FormStore.setCalcEmail(value);
      calcFormRef.setFieldsValue({
        emailItem: FormStore.PiiMaskFlag ? maskDetail(value) : value,
      });
      UserInput("EmailId", value, "", "");
    }
    if (tempObj["MobileNo"] !== undefined) {
      value = tempObj["MobileNo"];
      FormStore.setCalcPhone(value);
      calcFormRef.setFieldsValue({
        mobileItem: FormStore.PiiMaskFlag ? maskDetail(value) : value,
      });
      UserInput("MobileNo", value, "", "");
    }
    if (tempObj["Mobile"] !== undefined) {
      value = tempObj["Mobile"];
      FormStore.setCalcPhone(value);
      calcFormRef.setFieldsValue({
        mobileItem: FormStore.PiiMaskFlag ? maskDetail(value) : value,
      });
      UserInput("MobileNo", value, "", "");
    }

    if (tempObj["gender"] !== undefined) {
      value = tempObj["gender"];
      FormStore.setCalcGender(value);
      calcFormRef.setFieldsValue({ gender: value });
      UserInput("gender", value, "", "");
    }
    if (tempObj["relation"] !== undefined) {
      value = tempObj["relation"];
      FormStore.setCalcBuyingFor(value);
      calcFormRef.setFieldsValue({ buyingFor: value });
      UserInput("relation", value, "", "");
    }
    if (tempObj["dob"] !== undefined) {
      value = tempObj["dob"];
      FormStore.setCalcDob(value);
      calcFormRef.setFieldsValue({
        ageItem: maskFlag ? maskData(value) : value,
      });
      let fetchAge = await calculateAge(value);
      console.log("prefill logg", value, FormStore.calc_age);
      UserInput("dob", value, "", "");
      UserInput("age", FormStore.calc_age, "", "");
      window.dataLayer_dob = true;
    }

    if (tempObj["income"] !== undefined) {
      // value = Number(Number(tempObj["income"]))
      value =
        Number(tempObj["income"]) <= 250000
          ? 250000
          : Number(tempObj["income"]) <= 625000
            ? 625000
            : Number(tempObj["income"]) <= 875000
              ? 875000
              : Number(tempObj["income"]) <= 1250000
                ? 1250000
                : Number(tempObj["income"]) <= 1750000
                  ? 1750000
                  : Number(tempObj["income"]) <= 2000000
                    ? 2000000
                    : Number(tempObj["income"]);
      FormStore.setCalcAnualIncome(value);
      calcFormRef.setFieldsValue({
        annualItem: maskFlag ? maskData(value) : value,
      });
      UserInput("AnnualIncome", value, "", "");
    }
    if (tempObj["AnnualIncome"] !== undefined) {
      // value = Number(tempObj["AnnualIncome"])
      value =
        Number(tempObj["AnnualIncome"]) <= 250000
          ? 250000
          : Number(tempObj["AnnualIncome"]) <= 625000
            ? 625000
            : Number(tempObj["AnnualIncome"]) <= 875000
              ? 875000
              : Number(tempObj["AnnualIncome"]) <= 1250000
                ? 1250000
                : Number(tempObj["AnnualIncome"]) <= 1750000
                  ? 1750000
                  : Number(tempObj["AnnualIncome"]) <= 2000000
                    ? 2000000
                    : Number(tempObj["AnnualIncome"]);
      FormStore.setCalcAnualIncome(value);
      calcFormRef.setFieldsValue({
        annualItem: maskFlag ? maskData(value) : value,
      });
      UserInput("AnnualIncome", value, "", "");
    }

    // Quote Page // Level 2 //

    if (tempObj["premium"] !== undefined) {
      value = tempObj["premium"];
      FormStore.setInvest(value);
      UserInput("premium", value, "", "");
    }
    if (tempObj["mode"] !== undefined) {
      value = tempObj["mode"];
      var tempValue = value === "half-yearly" ? "Half-Yearly" : value;
      tempValue = await capitalize(tempValue);
      FormStore.setEvery(tempValue);
      UserInput("mode", value, "", "");
    }

    if (
      tempObj["term"] !== undefined &&
      ModalStore.invest_calc_quote !== true
    ) {
      value = Number(tempObj["term"]);
      FormStore.setPolicyTerm(value);
      UserInput("term", value, "", "");
    }
    if (tempObj["ppt"] !== undefined) {
      value = Number(tempObj["ppt"]);
      FormStore.setPayFor(value);
      UserInput("ppt", value, "", "");
    }
    if (tempObj["PPT"] !== undefined) {
      value = Number(tempObj["PPT"]);
      FormStore.setPayFor(value);
      UserInput("ppt", value, "", "");
    }
    // Removed to fix limited regular issue on recommended for section
    if (
      tempObj["paymentOption"] !== undefined &&
      ModalStore.invest_calc_quote !== true
    ) {
      value = tempObj["paymentOption"];
      var StoreVal = value === "regular_pay" ? "Regular" : "Limited";
      FormStore.setPaymentFreq(StoreVal);
      console.log("QFs:", value);
      UserInput("paymentOption", value, "", "");
    }
    if (tempObj["premiumPaymentOption"] !== undefined) {
      value = tempObj["premiumPaymentOption"];
      var LocalVal = value === "Regular_Pay" ? "regular_pay" : "limited_pay";
      var StoreVal = value === "Regular_Pay" ? "Regular" : "Limited";
      FormStore.setPaymentFreq(StoreVal);
      UserInput("paymentOption", LocalVal, "", "");
    }

    if (tempObj["paymentPref"] !== undefined) {
      value = tempObj["paymentPref"];
      var LocalVal = value === "RegularPay" ? "regular_pay" : "limited_pay";
      var StoreVal = value === "RegularPay" ? "Regular" : "Limited";
      FormStore.setPaymentFreq(StoreVal);
      UserInput("paymentOption", LocalVal, "", "");
    }

    // Quote Funds // Level 3 //

    if (tempObj["riskProfile"] !== undefined) {
      // Aggressive
      var riskArray = ["Aggressive", "Balanced", "Conservative"];
      value = tempObj["riskProfile"];
      if (riskArray.includes(value)) {
        FormStore.setInvestStrat(value);
        UserInput("invest_strat", value.toLowerCase(), "", "");
      }
    }

    if (tempObj["invest_strat"] !== undefined) {
      value = await capitalize(tempObj["invest_strat"]);
      FormStore.setInvestStrat(value);
      UserInput("invest_strat", value.toLowerCase(), "", "");

      if (tempObj["invest_type"] !== undefined) {
        var investType = tempObj["invest_type"];
        var investArray = [
          "yourChoice",
          "yourAge",
          "strategyOne",
          "strategyTwo",
        ];
        if (investArray.includes(investType)) {
          var indexInvest = investArray.findIndex((x) => x === investType);
          FormStore.setFundsTab(indexInvest);
          UserInput("invest_type", investType, "", "");
        }
      }

      if (tempObj["selectedFunds"] !== undefined) {
        var selectedFunds = tempObj["selectedFunds"];
        FormStore.setInvestFundSelected([...selectedFunds]);
        UserInput("selectedFunds", selectedFunds, "", "");
      }
    }

    if (tempObj["funds"] !== undefined) {
      UserInput("funds", tempObj["funds"], "", "");
    }

    if (tempObj["fundCat"] !== undefined) {
      UserInput("fundCat", tempObj["fundCat"], "", "");
    }

    if (tempObj["swp"] !== undefined) {
      var swpVal = tempObj["swp"]["SWP"];
      var swpMode = tempObj["swp"]["SWP_mode"];
      var swpDate = tempObj["swp"]["SWP_payDate"];
      var swpPer = tempObj["swp"]["payout_per"];
      var swpYear = tempObj["swp"]["year"];
      console.info("swpPer Year :", swpPer);

      var swpValStore = swpVal === "No" ? "N" : "Y";
      FormStore.setCardOneRadio(swpValStore);
      console.info("swpValStore :", swpValStore);
      UserInput("swp", swpVal, "SWP", "");

      // FormStore.setTransferAmount(atsAmount)
      UserInput("swp", swpPer, "payout_per", "");

      UserInput("swp", swpYear, "year", "");

      var swpModeStore = await capitalize(tempObj["swp"]["SWP_mode"]);
      FormStore.setPaymentMode(swpModeStore);
      UserInput("swp", swpMode, "SWP_mode", "");

      if (swpDate === "1") swpDate = "5"; // Since Previous Value was 1 and now its 5
      FormStore.setPaymentDate(swpDate);
      UserInput("swp", swpDate, "SWP_payDate", "");
    }

    if (tempObj["ats"] !== undefined) {
      var atsVal = tempObj["ats"]["ats"];
      var atsAmount = tempObj["ats"]["amount"];
      var atsFrom = tempObj["ats"]["fundFrm"];
      var atsTo = tempObj["ats"]["fundTo"];
      var atsDot = tempObj["ats"]["date"];

      var atsValStore = atsVal === "No" ? "N" : "Y";
      FormStore.setCardTwoRadio(atsValStore);
      console.info("atsValStore :", atsValStore);
      UserInput("ats", atsVal, "ats", "");

      if (atsAmount !== "") {
        FormStore.setTransferAmount(atsAmount);
        UserInput("ats", atsAmount, "amount", "");
      }

      if (atsFrom !== "") {
        FormStore.setQuoteFrom(atsFrom);
        UserInput("ats", atsFrom, "fundFrm", "");
      }

      FormStore.setQuoteTo(atsTo);
      UserInput("ats", atsTo, "fundTo", "");

      if (atsDot === "1") atsDot = "5"; // Since Previous Value was 1 and now its 5
      FormStore.setQuoteDOT(atsDot);
      UserInput("ats", atsDot, "date", "");
    }

    FormStore.setShouldPersist(true);

    if (QDataFlag) {
      var isStepTrue =
        new URL(window.location.href).searchParams.get("Step") === "true";
      setTimeout(() => {
        if (isStepTrue) {
          calcFormRef.submit();
          HideLandingLoader();
        }
      }, 1000);
    }
  };

  const toggleBuyingFor = async (e) => {
    var value = e.target.value;
    await FormStore.setCalcBuyingFor(value);
    var dob = FormStore.calc_dob;
    await calculateAge(dob);
    UserInput("relation", value, "", "");
    console.info("Buying For :", FormStore.calc_buyingFor);
    DataLayerFn(
      `PolicyHolder_Selected||Calculator-Landing page|Buying For`,
      FormStore,
      "",
      "",
      value,
      "",
    );
  };

  const toggleGender = async (e) => {
    var value = e.target.value;
    await FormStore.setCalcGender(value);
    UserInput("gender", value, "", "");
    console.info("Gender :", FormStore.calc_gender);
  };

  const UserIncAge = (e) => {
    let switch_user_age = window.UserInput.age;
    if (switch_user_age < 26) {
      return e["below25"];
    } else if (switch_user_age > 25 && switch_user_age < 31) {
      return e["26to30"];
    } else if (switch_user_age > 30 && switch_user_age < 36) {
      return e["31to35"];
    } else if (switch_user_age > 35 && switch_user_age < 41) {
      return e["36to40"];
    } else if (switch_user_age > 40 && switch_user_age < 46) {
      return e["41to45"];
    } else if (switch_user_age > 45 && switch_user_age < 51) {
      return e["46to50"];
    } else if (switch_user_age > 50 && switch_user_age < 56) {
      return e["51to55"];
    } else if (switch_user_age > 55 && switch_user_age < 61) {
      return e["56to60"];
    } else if (switch_user_age > 60) {
      return e["above60"];
    }
  };

  const toggleAnnual = (value) => {
    value = AppStore.device === 0 ? value.target.value : value;
    FormStore.setCalcAnualIncome(value);
    UserInput("AnnualIncome", value, "", "");
    var invokeParent = ModalStore.invest_calc_quote
      ? "InvestNow"
      : "Lead Calculator";
    DataLayerFn(
      `AnnualIncome_Selected||Calculator-Landing page|${invokeParent}`,
      FormStore,
      "",
      "",
      "",
      "",
    );

    var premiumValue = "";
    var age_inc_json = calculatorForm["age_inc_json"];
    if (value === 250000) {
      premiumValue = UserIncAge(age_inc_json[250000]);
    } else if (value === 625000) {
      premiumValue = UserIncAge(age_inc_json[625000]);
    } else if (value === 875000) {
      premiumValue = UserIncAge(age_inc_json[875000]);
    } else if (value === 1250000) {
      premiumValue = UserIncAge(age_inc_json[1250000]);
    } else if (value === 1750000) {
      premiumValue = UserIncAge(age_inc_json[1750000]);
    } else if (value === 2000000) {
      premiumValue = UserIncAge(age_inc_json[2000000]);
    }
    UserInput("premium", premiumValue, "", "");
    quoteFormRef.setFieldsValue({ youInvest: addCommas(premiumValue) });
    FormStore.setInvest(premiumValue);
  };

  const toggleAnnualModal = () => {
    FormStore.setAIModal(true);
  };

  const toggleMobileToolTip = (e) => {
    e.preventDefault();
    if (AppStore.device === 0) {
      FormStore.setMobileModal(true);
    }
  };

  const DateBoi = async (e) => {
    if (e !== null) {
      Inputmask("99/99/9999", {
        placeholder: "DD/MM/YYYY",
        prefillYear: false,
      }).mask(e.target);
    }
  };

  const inputWithMaskOnChange = (e) => {
    var value = e.target.value;
    calculateAge(value);
    FormStore.setCalcDob(value);
    console.info("Age Change :", value);
  };

  const inputWithMaskOnPaste = (e) => {
    var value = e.target.value;
    calculateAge(value);
    FormStore.setCalcDob(value);
    // console.info("Age Change :", e)
  };

  const calculateAge = async (value) => {
    var min =
      FormStore.calc_buyingFor === "Child" ||
      FormStore.calc_buyingFor === "Grandchild"
        ? 0
        : 18;
    var max = 50;
    var flag = await ageValidation(value, min, max);
    console.info("Age Validation :", flag);
    await FormStore.setCalcAge(flag.age);
    if (flag.valid && Math.sign(flag.age) !== -1) {
      calcFormRef.setFields([{ name: "ageItem", errors: [] }]);
      window.dataLayer_dob = true;
    } else if (flag.age === -1 || flag.age === -2) {
      calcFormRef.setFields([{ name: "ageItem", errors: [flag.errorMsg] }]);
      window.dataLayer_dob = false;
    }
  };

  const phoneNumberInput = async (e) => {
    var value = e.target.value;
    value = await phoneValidation(value);
    await calcFormRef.setFieldsValue({ mobileItem: value });
    await FormStore.setCalcPhone(value);
    UserInput("MobileNo", value, "", "");
    console.info("Phone Number :", FormStore.calc_phone);
    let pattern =
      /^[6-9][0-9]{0,9}$/; /* Logic for passing network uuid values in datalayer */
    if (pattern.test(value) && value.length === 10) {
      await FormStore.setCalcMobileValid(true);
    } else {
      await FormStore.setCalcMobileValid(false);
    }
  };

  const handleMobileFocus = async () => {
    if (!FormStore.PiiMaskFlag) return;
    const value = calcFormRef.getFieldValue("mobileItem");
    if (!value) return;
    try {
      await calcFormRef.validateFields(["mobileItem"]);
      await FormStore.setCalcPhone("");
      await calcFormRef.setFieldsValue({
        mobileItem: "",
      });
    } catch (err) {
      console.log("Mobile not valid, skipping clear");
    }
  };

  const handleMobileBlur = async (e) => {
    const value = e.target.value;
    if (!FormStore.PiiMaskFlag || !value) return;
    try {
      await calcFormRef.validateFields(["mobileItem"]);
      await calcFormRef.setFieldsValue({
        mobileItem: maskDetail(value),
      });
    } catch (err) {
      console.log("Mobile not valid, skipping mask");
    }
  };

  const onChangeEmailInput = async (e) => {
    var value = e.target.value;
    value = await emailValidation(value);
    let validationResult = await emailValidation(value);
    value = value["email"];
    await calcFormRef.setFieldsValue({ emailItem: value });
    await FormStore.setCalcEmail(value);
    UserInput("EmailId", value, "", "");
    console.info("Email :", value);
    /* Below Logic for passing network uuid values in datalayer */
    if (validationResult.email.valid) {
      await FormStore.setCalcEmailValid(true);
    } else {
      await FormStore.setCalcEmailValid(false);
    }
  };

  const handleEmailFocus = async () => {
    if (!FormStore.PiiMaskFlag) return;
    const value = calcFormRef.getFieldValue("emailItem");
    if (!value) return;
    try {
      await calcFormRef.validateFields(["emailItem"]);
      await FormStore.setCalcEmail("");
      await calcFormRef.setFieldsValue({
        emailItem: "",
      });
    } catch (err) {
      console.log("Email not valid, skipping clear");
    }
  };

  const handleEmailBlur = async (e) => {
    const value = e.target.value;
    if (!FormStore.PiiMaskFlag || !value) return;
    try {
      await calcFormRef.validateFields(["emailItem"]);
      await calcFormRef.setFieldsValue({
        emailItem: maskDetail(value),
      });
    } catch (err) {
      console.log("Email not valid, skipping mask");
    }
  };

  const removeMandatory = async () => {
    await FormStore.setCalcClickTwo(false);
    calcFormRef.setFields([{ name: "mobileItem", errors: [] }]);
    calcFormRef.setFields([{ name: "emailItem", errors: [] }]);

    DataLayerFn(
      "SkipPersonalDetails_ClickHere||Calculator-Landing page|skip mandatory",
      FormStore,
      "",
      "",
      "Click here",
      "",
    );
  };

  const toggleCheckOne = async (e) => {
    var value = e.target.checked;
    if (value) {
      DataLayerFn(
        "ProductAssessment_T&CAccepted||Calculator-Landing page|ProductAssessment",
        FormStore,
        "",
        "",
        "",
        "",
      );
    }
    // console.info("Check One :", value)
    FormStore.setCalcCheckOne(value);
    UserInput("trai", value, "", "");
    UserInput("traiFlag", value ? "YES" : "NO", "", "");
  };

  const toggleCheckTwo = async (e) => {
    var value = e.target.checked;
    console.info("Check Two :", value);
    calcFormRef.setFieldsValue({ suitCheckbox: value });
    FormStore.setCalcCheckTwo(value);
    if (!value) {
      console.log("its me");
      FormStore.setSuitError(true);
    } else {
      FormStore.setSuitError(false);
    }
  };

  const forceCheckTwo = async () => {
    FormStore.setCalcCheckTwo(true);
    FormStore.setSuitabilityModal(true);
    DataLayerFn(
      "SuitabilityAnalysis_clicked||Calculator-Landing page|Suitability",
      FormStore,
      "",
      "",
      "Click here",
      "",
    );
  };

  const focusErrorField = async (error) => {
    try {
      var field = error["errorFields"][0]["name"][0];
      if (field === "ageItem") {
        dobInput.current.focus();
      } else if (field === "mobileItem") {
        mobInput.current.focus();
      } else if (field === "emailItem") {
        emailInput.current.focus();
      }
    } catch (e) {
      console.error(e);
    }
    //checking for checkTwo on fail
    if (FormStore.calc_checkTwo) {
      FormStore.setSuitError(true);
    }
    console.info("Error Valdiation :", field);
  };

  const handleClickOpen = async (values) => {
    CreateReactCookie();
    var result = values;
    // if (!result.suitCheckbox) {
    //   FormStore.setSuitError(true)
    //   return false
    // }
    setCalculatorCTADisabled(true);
    window.ReactOptionLead_Email = false;
    window.ReactOptionLead_Mobile = false;
    FormStore.setQuoteModal(true);

    if (!result.mobileItem && !result.emailItem) {
      // Both Empty & Undefined
      DataLayerFn(
        "GetQuote_SkipPersonalDetails||Calculator-Landing page|Skip Personal Details",
        FormStore,
        "",
        "Calculate Returns",
        "",
        "",
      );
    } else if (!result.mobileItem && result.emailItem) {
      // Only Mobile Empty & Undefined
      DataLayerFn(
        "GetQuote_EmailIDSubmitted||Calculator-Landing page|Email",
        FormStore,
        "",
        "Calculate Returns",
        "",
        "",
      );
      window.ReactOptionLead_Email = true;
    } else if (result.mobileItem && !result.emailItem) {
      // Only Email Empty & Undefined
      DataLayerFn(
        "LeadSubmitted_MobileNumber||Calculator-Landing page|MobileNumber",
        FormStore,
        "",
        "Calculate Returns",
        "",
        "",
      );
      window.ReactOptionLead_Mobile = true;
    } else {
      // Both Valid
      DataLayerFn(
        "LeadSubmitted||Calculator-Landing page|Calculate Returns",
        FormStore,
        "",
        "Calculate Returns",
        "",
        "",
      );
      window.ReactOptionLead_Email = true;
      window.ReactOptionLead_Mobile = true;
    }

    var tempTermStore = FormStore.quote_policyTerm;
    var tempRegLim = tempTermStore > 30;
    var custAge = FormStore.calc_age;
    var ageFlag = tempRegLim
      ? 99 - custAge === tempTermStore
        ? tempTermStore
        : 15
      : tempTermStore < 75 - custAge
        ? tempTermStore
        : 75 - custAge;
    var value = ageFlag; // Resets Policy Term For Regular and Age More Than 45 Issue.
    if (CommonStore.recommendedJourney) {
      value = 99 - custAge;
      CommonStore.setRecommendedJourney(false);
      console.log("RecJourney:", value);
    }
    if (tempTermStore !== value) {
      FormStore.setPolicyTerm(value);
      UserInput("term", value, "", "");
      var quoteFormValues = quoteFormRef.getFieldsValue(true);

      if (Object.entries(quoteFormValues).length > 0) {
        quoteFormRef.setFieldsValue({ policyTerm: value });
      }
      FormStore.setQuoteShouldUpdate(true);
    } else {
      FormStore.setQuoteShouldUpdate(false);
    }
    console.info("Age Flag :", tempTermStore, tempRegLim, custAge, ageFlag);
    try {
      const leadRes = await leadWSAPI(FormStore);
      const tracerAAPI = tracerAPI(FormStore, 1);
      const tracerBAPI = tracerAPI(FormStore, 2);
      if (typeof window.hj === "function") {
        window.hj =
          window.hj ||
          function () {
            (window.hj.q = window.hj.q || []).push(arguments);
          };
        window.hj("event", "sng_qp");
        window.hj("stateChange", "sng_qp");
        console.log("hotjar calculator quotepage");
      }
    } catch (e) {
      console.error("Issue in LeadWS Response", e);
    }
    console.info("hhh", FormStore.calc_checkTwo);

    if (FormStore.calc_checkTwo) {
      console.log("suit error why me", FormStore.calc_suitError);
      FormStore.setSuitError(false);
      if (FormStore.calc_buyingFor !== "Self") {
        FormStore.setDependentJourney(true);
        console.warn(
          "DependentJourney != self",
          FormStore.calc_dependentJourney,
        );
        setCalculatorCTADisabled(false);
      } else {
        //Call Suitability
        window.OpenSuitabilityPop();
        FormStore.setDependentJourney(false);
        console.warn(
          "DependentJourney == self",
          FormStore.calc_dependentJourney,
        );
        const SandGRef = SaveNGrowForm.current;
        let UserDataJSON = getUserDataJSON();
        window.demoJson = UserDataJSON;
        window.UserDataJSON = UserDataJSON;
        UserDataJSON = btoa(BlowFishReact(true, "", UserDataJSON));
        document.getElementById("bolData").value = UserDataJSON;
        SandGRef.action = window.location.href.includes("testing")
          ? "https://buyuat.iprulifeinsurance.com/digiuatnew/PartnerIntegration.htm"
          : "https://buy.icicilife.com/buy/PartnerIntegration.htm";
        setCalculatorCTADisabled(false);
        window.proceedToAppform = () => {
          setCalculatorCTADisabled(true);
          SandGRef.submit();
        };
      }
    } else {
      console.log("its me 2");
      FormStore.setSuitError(true);
      suitInput.current.focus();
    }
  };

  const submitLeadViaEmail = () => {
    calcFormRef.submit();
  };

  const toggleViewMore = () => {
    setViewMore((prev) => !prev);
  };

  return (
    <>
      <Card
        className={`CalculatorCard Wealth`}
        title={
          AppStore.device === 1 &&
          !ModalStore.invest_calc_quote && (
            <div className="CalculatorTitle">{`Plan start at just ₹2,400 p.m. Invest Now!`}</div>
          )
        }
        style={{
          width: AppStore.device === 0 ? "100%" : "450px",
          backgroundColor: "whitesmoke",
          marginTop: AppStore.device === 0 ? 0 : "70px",
          marginRight: AppStore.device === 0 ? 0 : "4.41vw",
        }}
      >
        <div className={`CalculatorFormTitleParent Wealth`}>
          {!ModalStore.invest_calc_quote && (
            <div className="CalculatorFormTitle">
              {AppStore.device === 0 && (
                <div className="CalculatorTitle">
                  {`Plan starts at just ₹2,400 p.m. Invest Now!`}{" "}
                </div>
              )}
              {AppStore.device === 1 ? (
                <h2 className="guranteeIncomeCalc">
                  {"ICICI Life Capital Guarantee Calculator"}
                </h2>
              ) : (
                <h2 className="guranteeIncomeCalc">
                  {"ICICI Life Capital Guarantee Calculator"}
                  {/* <div className="guranteeIncomeCalc_Title">{calculatorForm["calcTitle"][FormStore.calc_type["key"]]["title"]}</div> */}
                </h2>
              )}
            </div>
          )}
          <AI_Modal />
          <MobileModal />
          {/* {!ModalStore.invest_calc_quote && !FormStore.persona_Validity && <RadioCheck imgheight={"17px"} imgwidth={"17px"} ConfigObj={ConfigObj} CpName={"Calculator"} calcForm={calcFormRef} />} */}
          <div className="Calculator_FormContainer">
            <Form
              layout={"vertical"}
              form={calcFormRef}
              onFinish={handleClickOpen}
              onFinishFailed={focusErrorField}
              initialValues={{
                buyingFor: FormStore.calc_buyingFor,
                gender: FormStore.calc_gender,
                ageItem: FormStore.calc_dob,
                annualItem: FormStore.calc_annual,
                emailItem: FormStore.calc_email,
                mobileItem: FormStore.calc_phone,
                ndncCheckbox: FormStore.calc_checkOne,
                suitCheckbox: FormStore.calc_checkTwo,
              }}
            >
              {!ModalStore.invest_calc_quote && (
                <RadioGroup
                  className="buyingFor"
                  formName={"buyingFor"}
                  styleName="radioBuyFor"
                  formClass={"CalculatorItem_BuyFor"}
                  type={1}
                  dynamicTitle={""}
                  jsonData={calculatorForm[`buyingFor_Wealth`]}
                  reverse={false}
                  // propValue={FormStore.calc_gender}
                  onChange={toggleBuyingFor}
                  condition={
                    FormStore.calc_gender === "Transgender" ? "Self" : ""
                  }
                  extraCon={
                    FormStore.calc_age !== "" &&
                    FormStore.calc_age > 2 &&
                    FormStore.calc_age < 18
                      ? ["Spouse"]
                      : []
                  }
                  disabled={disableQData}
                />
              )}
              {!ModalStore.invest_calc_quote && (
                <hr className="Calculator_RadioHR" />
              )}

              <RadioGroup
                className="gender"
                formName={"gender"}
                styleName="radioGender"
                formClass={"CalculatorItem_Gender"}
                type={1}
                dynamicTitle={
                  FormStore.calc_buyingFor === "Self" ||
                  !FormStore.calc_buyingFor
                    ? ""
                    : `Your ${FormStore.calc_buyingFor}’s  Gender`
                }
                jsonData={calculatorForm["gender"]}
                reverse={true}
                // propValue={FormStore.calc_gender}
                onChange={toggleGender}
                condition={
                  FormStore.calc_buyingFor !== "Self" ? "Transgender" : ""
                }
                disabled={disableQData}
              />

              <div
                className={AppStore.device === 1 ? "flexByRow" : "flexByColumn"}
              >
                {AppStore.device === 1 && (
                  <Form.Item
                    name="ageItem"
                    className={"CalculatorItem_DOB"}
                    validateFirst={true}
                    disabled={disableQData}
                    rules={[
                      {
                        required: true,
                        message: "Please enter date of birth.",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          var ageItem = getFieldValue("ageItem");
                          if (ageItem <= 0 || ageItem === undefined) {
                            return Promise.reject(
                              "Please enter date of birth.",
                            );
                          } else if (FormStore.calc_age === -1) {
                            return Promise.reject("Enter valid date of birth");
                          } else if (FormStore.calc_age === -2) {
                            var min =
                              FormStore.calc_buyingFor === "Child" ||
                              FormStore.calc_buyingFor === "Grandchild"
                                ? 0
                                : 18;
                            var max = 50;
                            return Promise.reject(
                              `This option is available only for age between ${min} to ${max} years.`,
                            );
                          } else {
                            console.info("Value ageItem :", ageItem);
                            UserInput("age", FormStore.calc_age, "", "");
                            UserInput("dob", ageItem, "", "");
                            return Promise.resolve();
                          }
                        },
                      }),
                    ]}
                    label={
                      <div className="dobIncomeTitle">
                        {FormStore.calc_buyingFor === "Self" ||
                        !FormStore.calc_buyingFor
                          ? "Date of Birth"
                          : `Your ${FormStore.calc_buyingFor}’s  Date of Birth`}
                      </div>
                    }
                  >
                    <Input
                      className={`js-dobInput ${AppStore.device === 1 && "width190"}`}
                      type={"tel"}
                      ref={dobInput}
                      placeholder={"DD/MM/YYYY"}
                      onFocus={DateBoi}
                      onChange={inputWithMaskOnChange}
                      onPaste={inputWithMaskOnPaste}
                      disabled={disableQData}
                      suffix={
                        <span
                          className={`xxYears ${FormStore.calc_dob && Math.sign(FormStore.calc_age) === 1 ? "Valid" : "Invalid"}${disableQData ? " qDisabled" : ""}`}
                        >
                          {FormStore.calc_age + " Years old"}
                        </span>
                      }
                    />
                  </Form.Item>
                )}
                <RadioGroup
                  placeholder={"Select your income"}
                  formClass={`CalculatorItem_Income ${ModalStore.invest_calc_quote ? "AnnualIncomeDropdown" : ""}`}
                  className="dobIncomeTitle"
                  styleName="radioAnnualIncome"
                  type={AppStore.device === 0 ? 1 : 0}
                  dynamicTitle={
                    FormStore.calc_buyingFor === "Self" ||
                    !FormStore.calc_buyingFor
                      ? ""
                      : `Your Annual Income`
                  }
                  jsonData={calculatorForm["income"]}
                  onChange={toggleAnnual}
                  infoIcon={true}
                  formName={"annualItem"}
                  // disabled={disableQData}
                  validate={true}
                  ddClassName={
                    ModalStore.invest_calc_quote
                      ? "App_Matrix .AnnualIncomeDropdown"
                      : ""
                  }
                  onToolTipClick={
                    AppStore.device === 0 ? toggleAnnualModal : null
                  }
                  overlayClassName={
                    ModalStore.invest_calc_quote ? "AnnualIncomeDropdown" : ""
                  }
                  validateMesssage={"Select annual income"}
                />
              </div>
              {AppStore.device === 0 && (
                <div className={"flexByRow mobileFlexRow"}>
                  <Form.Item
                    name="ageItem"
                    className={"CalculatorItem_DOB"}
                    validateFirst={true}
                    rules={[
                      {
                        required: true,
                        message: "Please enter date of birth.",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          var ageItem = getFieldValue("ageItem");
                          if (ageItem <= 0 || ageItem === undefined) {
                            return Promise.reject(
                              "Please enter date of birth.",
                            );
                          } else if (FormStore.calc_age === -1) {
                            return Promise.reject("Enter valid date of birth");
                          } else if (FormStore.calc_age === -2) {
                            var min =
                              FormStore.calc_buyingFor === "Child" ||
                              FormStore.calc_buyingFor === "Grandchild"
                                ? 0
                                : 18;
                            var max = 50;
                            return Promise.reject(
                              `This option is available only for age between ${min} to ${max} years.`,
                            );
                          } else {
                            console.info("Value ageItem :", ageItem);
                            UserInput("age", FormStore.calc_age, "", "");
                            UserInput("dob", ageItem, "", "");
                            return Promise.resolve();
                          }
                        },
                      }),
                    ]}
                    label={
                      <div className="dobIncomeTitle">
                        {FormStore.calc_buyingFor === "Self" ||
                        !FormStore.calc_buyingFor
                          ? "Date of Birth"
                          : `Your ${FormStore.calc_buyingFor}’s  Date of Birth`}
                      </div>
                    }
                  >
                    <Input
                      className={`js-dobInput ${AppStore.device === 1 && "width190"}`}
                      type={"tel"}
                      ref={dobInput}
                      placeholder={"DD/MM/YYYY"}
                      onFocus={DateBoi}
                      onChange={inputWithMaskOnChange}
                      onPaste={inputWithMaskOnPaste}
                      suffix={
                        <span
                          className={`xxYears ${FormStore.calc_dob && Math.sign(FormStore.calc_age) === 1 ? "Valid" : "Invalid"}${disableQData ? " qDisabled" : ""}`}
                        >
                          {FormStore.calc_age + " Years old"}
                        </span>
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    name="mobileItem"
                    className={"CalculatorItem_Mobile"}
                    validateFirst={true}
                    rules={[
                      {
                        required: FormStore.calc_clickTwo,
                        message: "Enter 10 digit mobile number",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          var mobileItem = getFieldValue("mobileItem");
                          var pattern = /^[6-9][0-9]{0,9}$/;
                          var negativeMobile = ["9920667766", "8069385555"];
                          const isMasked =
                            mobileItem && mobileItem.includes("X");
                          // Skip validation for masked prefilled numbers
                          if (isMasked && FormStore.PiiMaskFlag) {
                            return Promise.resolve();
                          }
                          // console.info("Mobile ReGex :", pattern.test(mobileItem))
                          if (mobileItem && !disableQData) {
                            if (
                              mobileItem <= 999999999 ||
                              !pattern.test(mobileItem) ||
                              negativeMobile.includes(mobileItem)
                            ) {
                              return Promise.reject(
                                "Enter 10 digit mobile number",
                              );
                            } else {
                              return Promise.resolve();
                            }
                          } else {
                            return Promise.resolve();
                          }
                        },
                      }),
                    ]}
                    label={
                      <div
                        className={`${FormStore.calc_buyingFor} mobileEmailTitle`}
                        onMouseEnter={() => mobInput.current.blur()}
                      >
                        {FormStore.calc_buyingFor === "Self" ||
                        !FormStore.calc_buyingFor
                          ? "Mobile Number"
                          : `Your Mobile Number`}
                        <span onClick={toggleMobileToolTip}>
                          <IconTooltip
                            title={
                              "Existing customers please put your existing mobile no. & get waiver of docs & short-application if applicable"
                            }
                            zIndex={AppStore.device === 0 ? -1 : null}
                          />
                        </span>
                      </div>
                    }
                  >
                    <Input
                      ref={mobInput}
                      disabled={disableQData}
                      placeholder="10 digit mobile number"
                      className={`js-mobileNo suitablity_mobilenumber leadmob ${AppStore.device === 1 && "width190"}`}
                      type={"tel"}
                      value={FormStore.calc_phone}
                      maxLength={10}
                      onChange={phoneNumberInput}
                      onFocus={handleMobileFocus}
                      onBlur={handleMobileBlur}
                    />
                  </Form.Item>
                </div>
              )}
              <div
                className={AppStore.device === 1 ? "flexByRow" : "flexByColumn"}
              >
                {AppStore.device === 1 && (
                  <Form.Item
                    name="mobileItem"
                    className={"CalculatorItem_Mobile"}
                    validateFirst={true}
                    rules={[
                      {
                        required: FormStore.calc_clickTwo,
                        message: "Enter 10 digit mobile number",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          var mobileItem = getFieldValue("mobileItem");
                          var pattern = /^[6-9][0-9]{0,9}$/;
                          var negativeMobile = ["9920667766", "8069385555"];
                          const isMasked =
                            mobileItem && mobileItem.includes("X");
                          // Skip validation for masked prefilled numbers
                          if (isMasked && FormStore.PiiMaskFlag) {
                            return Promise.resolve();
                          }
                          // console.info("Mobile ReGex :", pattern.test(mobileItem))
                          if (mobileItem && !disableQData) {
                            if (
                              mobileItem <= 999999999 ||
                              !pattern.test(mobileItem) ||
                              negativeMobile.includes(mobileItem)
                            ) {
                              return Promise.reject(
                                "Enter 10 digit mobile number",
                              );
                            } else {
                              return Promise.resolve();
                            }
                          } else {
                            return Promise.resolve();
                          }
                        },
                      }),
                    ]}
                    label={
                      <div
                        className="mobileEmailTitle"
                        onMouseEnter={() => mobInput.current.blur()}
                      >
                        {FormStore.calc_buyingFor === "Self" ||
                        !FormStore.calc_buyingFor
                          ? "Mobile Number"
                          : `Your Mobile Number`}
                        <a onClick={toggleMobileToolTip}>
                          <IconTooltip
                            title={
                              "Existing customers please put your existing mobile no. & get waiver of docs & short-application if applicable"
                            }
                            zIndex={AppStore.device === 0 ? -1 : null}
                          />
                        </a>
                      </div>
                    }
                  >
                    <Input
                      ref={mobInput}
                      disabled={disableQData}
                      placeholder="10 digit mobile number"
                      className={`js-mobileNo suitablity_mobilenumber leadmob ${AppStore.device === 1 && "width190"}`}
                      type={"tel"}
                      value={FormStore.calc_phone}
                      maxLength={10}
                      onChange={phoneNumberInput}
                      onFocus={handleMobileFocus}
                      onBlur={handleMobileBlur}
                    />
                  </Form.Item>
                )}
                <Form.Item
                  name="emailItem"
                  className={"CalculatorItem_Email"}
                  validateFirst={true}
                  rules={[
                    {
                      required: FormStore.calc_clickTwo,
                      message: "Enter valid email id",
                    },
                    ({ getFieldValue }) => ({
                      async validator(_, value) {
                        var emailItem = getFieldValue("emailItem");
                        const email = await emailValidation(emailItem);
                        if (emailItem) {
                          if (email.valid) {
                            FormStore.setCalcEmail(email.email);
                            return Promise.resolve();
                          } else {
                            return Promise.reject("Enter valid email id");
                          }
                        } else {
                          return Promise.resolve();
                        }
                      },
                    }),
                  ]}
                  label={
                    <div className="mobileEmailTitle">
                      {FormStore.calc_buyingFor === "Self" ||
                      !FormStore.calc_buyingFor
                        ? "Email ID"
                        : `Your Email ID`}
                    </div>
                  }
                >
                  <Input
                    ref={emailInput}
                    placeholder="abc@gmail.com"
                    disabled={disableQData}
                    className={`js-emaiId suitablity_emailid leademail ${AppStore.device === 1 && "width180"}`}
                    onChange={onChangeEmailInput}
                    onPressEnter={submitLeadViaEmail}
                    onFocus={handleEmailFocus}
                    onBlur={handleEmailBlur}
                  />
                </Form.Item>
              </div>
              <div className="CheckboxGroup">
                <Form.Item
                  name="ndncCheckbox"
                  className="flexByRow columnGap5 CalculatorItem_CheckOne"
                  valuePropName="checked"
                >
                  <Checkbox onChange={toggleCheckOne} defaultChecked={true} />
                </Form.Item>
                <span className="checkboxLabel">
                  {viewMore ? NDNC_DISCLAIMER_TRUNCATED : NDNC_DISCLAIMER_FULL}{" "}
                  <a
                    className="checkboxLabel formCheckClick2"
                    onClick={toggleViewMore}
                  >
                    {viewMore ? "View More" : "View Less"}
                  </a>
                  <br />
                  {FormStore.calc_clickTwo && (
                    <span>
                      <br />
                      {
                        "If you wish to be redirected to calculate your premium without sharing your personal details, "
                      }
                      <a
                        className="checkboxLabel formCheckClick2"
                        onClick={removeMandatory}
                      >
                        click here
                      </a>
                      .
                    </span>
                  )}
                </span>
              </div>
              {/* {!FormStore.suitabilityFlag && (
              <div className="CheckboxGroup">
                <Form.Item name="suitCheckbox" className="flexByRow columnGap5 CalculatorItem_CheckTwo">
                    <Checkbox onChange={toggleCheckTwo} checked={FormStore.calc_checkTwo} ref={suitInput} />
                  </Form.Item>
                <span className="checkboxLabel">
                  {"To undergo suitability analysis, please "}
                  {/* <a className="checkboxLabel formCheckClick1" onClick={forceCheckTwo}>
                    click here
                  </a>
                  <span className="checkboxLabel formCheckClick1" onClick={forceCheckTwo}>
                    click here
                  </span>
                  . <br />
                  {"By not undergoing the suitability analysis, you confirm to purchase the policy based on your independent assessment of the suitability of the product."}
                  {FormStore.calc_clickTwo && (
                    <span>
                      <br />
                      {"If you wish to be redirected to calculate your premium without sharing your personal details, "}
                      <a className="checkboxLabel formCheckClick2" onClick={removeMandatory}>
                        click here
                      </a>
                      .
                    </span>
                  )}
                </span>
              </div>
            )} */}
              {console.log("suiterror", FormStore.calc_suitError)}
              <div
                className={`suitCheckError ${!FormStore.calc_suitError && "hideSuitError"}`}
              >
                Mandatory Field
              </div>
              {!ModalStore.invest_calc_quote && (
                <GenericButton
                  disabled={CalculatorCTADisabled}
                  title={
                    AppStore.device === 0
                      ? "Check Returns"
                      : "Let’s Calculate Returns"
                  }
                  className="calculateFormDiv"
                />
              )}
            </Form>
          </div>
        </div>
      </Card>
      <form ref={SaveNGrowForm} id="SaveNGrowForm" method={"POST"}>
        <input id={"bolData"} name="bolData" type={"hidden"} />
      </form>
      <DependentModal submitRef={SaveNGrowForm.current} />
    </>
  );
});

export default Calculator;
